import { createSlice } from '@reduxjs/toolkit';
import { setAppointment } from '../roleSlice';

const initialState = {
  todayAppointments: null,
  totalCount: 0
};
const todayAppointmentSlice = createSlice({
  name: 'todayAppointmentSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setTodayAppointment(state, action) {
      state.todayAppointments = action?.payload;
    },
    setTotalCount(state, action) {
      state.totalCount = action?.payload;
    }
  }
});
export const { setTodayAppointment, setTotalCount } = todayAppointmentSlice.actions;
export default todayAppointmentSlice.reducer;
